/** Slugs reserved for existing TanStack Router routes — custom pages cannot use these. */
export const RESERVED_PAGE_SLUGS = new Set([
  "admin",
  "about",
  "careers",
  "client-stories",
  "contact",
  "industries",
  "insights",
  "leadership",
  "leaders",
  "privacy",
  "services",
  "terms",
  "p",
  "home",
]);

export function isReservedPageSlug(slug: string): boolean {
  return RESERVED_PAGE_SLUGS.has(slug.toLowerCase());
}
